import { useState } from "react";
import { MapPin, Clock } from "lucide-react";
import { Chapter, Reveal } from "./Reveal";
import { TUTORS, LOCATIONS } from "../../data/content";

export const Availability = () => {
    const [active, setActive] = useState("oliver");
    const tutor = TUTORS.find((t) => t.id === active);

    return (
        <section
            id="availability"
            data-testid="availability-section"
            className="py-28 md:py-40 bg-cream/50"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <Chapter
                    index="Ch. 09"
                    eyebrow="Where & when"
                    title={
                        <>
                            Weekly availability
                            <br />
                            <em className="text-navy">&amp; locations.</em>
                        </>
                    }
                    testid="availability-heading"
                />

                <div className="grid lg:grid-cols-12 gap-14">
                    <div className="lg:col-span-7">
                        <div className="flex border border-ink/15 w-max mb-8">
                            {TUTORS.map((t) => (
                                <button
                                    key={t.id}
                                    data-testid={`availability-tab-${t.id}`}
                                    onClick={() => setActive(t.id)}
                                    className={`px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${
                                        active === t.id
                                            ? "bg-ink text-bone"
                                            : "text-slate2 hover:text-ink"
                                    }`}
                                >
                                    {t.name.split(" ")[0]}
                                </button>
                            ))}
                        </div>
                        <div data-testid={`availability-table-${tutor.id}`}>
                            {tutor.availability.map((a) => (
                                <div
                                    key={a.day}
                                    className="flex items-baseline justify-between border-t hairline py-4"
                                >
                                    <span className="flex items-center gap-3 text-ink text-sm md:text-base">
                                        <Clock className="w-3.5 h-3.5 text-oxblood" strokeWidth={1.75} />
                                        {a.day}
                                    </span>
                                    <span className="font-mono text-xs md:text-sm text-slate2">
                                        {a.time}
                                    </span>
                                </div>
                            ))}
                            <p className="mt-6 text-xs text-slate2/80 leading-relaxed max-w-md">
                                {tutor.id === "ashton"
                                    ? "On-request slots can usually be arranged within about two weeks. Additional times may be available — just ask."
                                    : "Times may shift week to week — get in touch to lock in a regular slot."}{" "}
                                Library sessions for {tutor.name.split(" ")[0]}: {tutor.library}.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-5 space-y-px">
                        {LOCATIONS.map((l, i) => (
                            <Reveal key={l.title} delay={i * 0.08}>
                                <div
                                    data-testid={`location-${l.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                    className="bg-bone border border-ink/10 p-7"
                                >
                                    <div className="flex items-center gap-3 mb-2">
                                        <MapPin className="w-4 h-4 text-oxblood" strokeWidth={1.75} />
                                        <h3 className="font-serif text-xl text-ink">{l.title}</h3>
                                    </div>
                                    <p className="text-slate2 text-sm leading-relaxed">{l.body}</p>
                                </div>
                            </Reveal>
                        ))}
                        <Reveal delay={0.25}>
                            <p className="text-xs text-slate2/80 pt-5 leading-relaxed">
                                Individual one-on-one sessions at all locations.
                                In-person sessions are offered within roughly a 15-minute drive,
                                at the tutor's discretion.
                            </p>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
};
